import { UserRecord } from "../db";

export default function getPendingReviewSessionIndex(data: UserRecord): number {
  return typeof data.lastReviewSessionIndex === "number"
    ? data.lastReviewSessionIndex + 1
    : 0;
}
